import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SpurToast, ToastrService } from 'src/app/services/toastr.service';

@Component({
	selector: 'app-spur-toaster',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './spur-toaster.component.html',
	styleUrls: ['./spur-toaster.component.css']
})
export class SpurToasterComponent implements OnInit, OnDestroy {
	toasts: SpurToast[] = [];
	private sub?: Subscription;

	constructor(private toastr: ToastrService) {}

	ngOnInit(): void {
		this.sub = this.toastr.toasts$.subscribe((toasts) => {
			this.toasts = toasts;
		});
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	dismiss(id: number): void {
		this.toastr.dismiss(id);
	}
}
